import ReactDOM from 'react-dom';
import { Chart, registerables } from 'chart.js';
// import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";
import 'bootstrap/dist/css/bootstrap.min.css';
import './_metronic/assets/sass/style.scss';
import { App } from './app/App';

const queryClientProvider = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    }
  }
})

const { PUBLIC_URL } = process.env;

Chart.register(...registerables)

ReactDOM.render(
  <>
    <QueryClientProvider client={queryClientProvider}>
      <App basename={PUBLIC_URL} />
      {/* <ReactQueryDevtools></ReactQueryDevtools> */}
    </QueryClientProvider>
  </>,
  // <MetronicI18nProvider>
  //   {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
  //   <App basename={PUBLIC_URL} />
  // </MetronicI18nProvider>,
  document.getElementById('root')

)
document.getElementById('root').className = "d-flex flex-column flex-root";